import { createContext, MouseEvent, useContext } from 'react';

export type ContextType = {
  isOpen: boolean;
  closable: boolean;
  autofocus: boolean;
  isOutsideClickable: boolean;
  onClose: (event: MouseEvent) => void;
};

export const ModalContext = createContext({} as ContextType);

export const useModalContext = (): ContextType => (
  useContext(ModalContext)
);
